import { useState } from "react";

export function AdminLogin({ onLogin }: { onLogin: (token: string) => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (!res.ok) {
        setError("Falsches Passwort.");
        return;
      }
      const { token } = (await res.json()) as { token: string };
      localStorage.setItem("blog_token", token);
      onLogin(token);
    } catch {
      setError("Verbindungsfehler.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="admin-page">
      <div className="noise-overlay" aria-hidden="true" />
      <div className="admin-login-wrap">
        <form className="admin-login" onSubmit={handleSubmit}>
          <h1 className="admin-login-title">Admin</h1>
          {error && <p className="admin-error">{error}</p>}
          <input
            className="admin-input"
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
          />
          <button className="admin-btn" type="submit" disabled={loading}>
            {loading ? "…" : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
